import {PayloadAction, createSlice} from '@reduxjs/toolkit';

interface IAddPictureMyStore {
  imageFile: File | null;
  cropedImage: File | null;
}
interface IImage {
  imageFile: File | null;
}

const initialState: IAddPictureMyStore = {
  imageFile: null,
  cropedImage: null,
};

export const addPictureMyStore = createSlice({
  name: 'PictureMyStore',
  initialState,
  reducers: {
    addingImage: (state, action: PayloadAction<IImage>) => {
      state.imageFile = action.payload.imageFile;
    },
    addingCropedImage: (state, action: PayloadAction<File>) => {
      state.cropedImage = action.payload;
    },
    clearImage: state => {
      state.imageFile = null;
    },
    clearAllData: state => {
      state.imageFile = null;
      state.cropedImage = null;
    },
  },
});

export const {addingImage, clearAllData, clearImage, addingCropedImage} =
  addPictureMyStore.actions;

export default addPictureMyStore.reducer;
